import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { ace_hooks } from '@axo/shared/data-access/hooks';
import { Classes } from '@blueprintjs/core';
import { useBucketsActions, useSearchTabActions } from '../../../store';
import { MenuNode } from './menuNode';
import { BucketStats } from './BucketStats';
import styles from './styles.module.css';

export function useBucketsNodes(marketCountry: string): MenuNode[] {
  const navigate = useNavigate();

  const { selectTab } = useSearchTabActions();
  const { selectBucket } = useBucketsActions();
  const buckets = ace_hooks.useBuckets(marketCountry);

  const nodes = useMemo<MenuNode[]>(() => {
    if (!buckets.data || buckets.data.length < 1) {
      return [
        {
          id: '478A6573-DF23-4EB8-AADF-A817D59E750E',
          label: 'No buckets',
          className: Classes.TEXT_MUTED,
        },
      ];
    }

    return buckets.data.map((bucket) => ({
      id: 'buckets/' + bucket.ID,
      label: bucket.Name,
      secondaryLabel: <BucketStats id={bucket.ID} />,
      nodeData: {
        onClick: () => {
          selectBucket(bucket.ID);
          selectTab('buckets');
          navigate('/search');
        },
      },
    }));
  }, [buckets.data, selectBucket, selectTab, navigate]);

  return useMemo(
    () => [
      {
        id: 'AC118BF2-85A4-481A-B279-7FFD95CAF29D',
        hasCaret: true,
        icon: 'box',
        label: 'Buckets',
        className: styles.clickable,
        secondaryLabel: `(${buckets.data?.length ?? 0})`,
        childNodes: nodes,
      },
    ],
    [nodes, buckets.data?.length],
  );
}
